import { ApplicationConfig, CSP_NONCE, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

// Import services
import { HttpService } from './services/http.service';
import { AuthService } from './services/auth.service';
import { PermissionService } from './services/permission.service';
import { ConfigService } from './services/config.service';
import { APP_CONFIG } from './services/config.token';
import { PatientService } from './services/patient/patient.service';

// authTokenInterceptor and httpErrorInterceptor are not registered here —
// HttpService handles auth headers and 401 error handling directly.

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';

export const appConfig: ApplicationConfig = {
  providers: [
        {
            provide: CSP_NONCE,
            useValue: nonce,
        },
        provideZonelessChangeDetection(),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withViewTransitions()
        ),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        importProvidersFrom(
            TranslateModule.forRoot({ defaultLanguage: 'en' })
        ),
        ...provideTranslateHttpLoader({ prefix: 'i18n/', suffix: '.json' }),
        { provide: APP_CONFIG, useValue: environment },
        // Core singleton services
        HttpService,
        AuthService,
        PermissionService,
        ConfigService,
        PatientService
    ]
};
